<template>
  <div>
    <px-view-header title="Gestão de entregas" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-gestao-entregas-lista/>
  </div>
</template>

<script>
import GestaoEntregasLista from '@/modules/gestao-entregas/GestaoEntregasLista.vue';

export default {
  data() {
    return {
      breadcrumbs: [
        { text: 'Gestão de compras' },
        { text: 'Gestão de entregas' },
      ],
    };
  },
  components: {
    pxGestaoEntregasLista: GestaoEntregasLista,
  },
};
</script>
